module.exports = __webpack_public_path__ + "static/img/manual_ja_18.7233557.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_18.png
// module id = qH06
// module chunks = 4